import { jsonFetch } from "@/lib/helpers";
import { KrossRoom } from "../../../models/integrations/kross.models";
import { getKrossRoomsUrl } from "./api-url.constants";
import { KrossRoomsApiDTO } from "./dtos/kross-rooms.api.dto";
import { mapKrossRoomsDTOToKrossRooms } from "./mappers/kross-rooms.mapper";

export const getKrossRooms = async (userId?: string): Promise<KrossRoom[]> => {
  const response = await jsonFetch<KrossRoomsApiDTO>(getKrossRoomsUrl(userId));
  return mapKrossRoomsDTOToKrossRooms(response);
};
